import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { raisedPanelSx } from '@/shared/ui/panelShadowStyles';
import { s } from '@/theme/tokens';
import { Box, Button, Stack } from '@/ui';
import { ErrorStatePanel, toTitleCaseWords } from '@/ui/composites';
import { useBreadcrumbs } from '@/ui/layout/breadcrumbsContext';
import { Section } from '@/ui/layout/Section';
import { PageShell } from '@/ui/primitives/PageShell';
import type { ReactElement } from 'react';

type NotFoundScreenProps = {
  title?: string;
  body?: string;
  backTo?: string;
  backLabel?: string;
};

export const NotFoundScreen = ({
  title = 'Page Not Found',
  body = 'The page you are looking for does not exist. Check the URL or head back.',
  backTo = '/',
  backLabel = 'Go Back',
}: NotFoundScreenProps): ReactElement => {
  const { setOverrideVisible, clearOverride } = useBreadcrumbs();

  useEffect(() => {
    setOverrideVisible(false);
    return () => {
      clearOverride();
    };
  }, [clearOverride, setOverrideVisible]);

  return (
    <PageShell maxWidth="xs" paddingX="lg" paddingY="xl" paddingBottom="xl">
      <Stack gap="xl" sx={{ pt: s('5xl') }}>
        <Section>
          <Box sx={{ width: '100%' }}>
            <ErrorStatePanel
              title={title}
              body={body}
              actions={
                <Button component={RouterLink} to={backTo} variant="primary">
                  {toTitleCaseWords(backLabel)}
                </Button>
              }
              sx={raisedPanelSx}
            />
          </Box>
        </Section>
      </Stack>
    </PageShell>
  );
};
